module.exports = __webpack_public_path__ + "img/PayPal.1a4f12eb.png";